import MDButton from 'components/MDButton';
import React from 'react';
function Button({ children, ...props }) {
  const newProps = {
    ...props,
    className: `${props.className} hoverPointer`,
  };
  return <MDButton  {...newProps}>{children}</MDButton>;
}

export default Button;
